import { Profession } from '@/enums/profession';

export const professionMoxie: Record<number, number> = {
    [Profession.Alchemy]: 3256,
    [Profession.Blacksmithing]: 3257,
    [Profession.Enchanting]: 3258,
    [Profession.Engineering]: 3259,
    [Profession.Herbalism]: 3260,
    [Profession.Inscription]: 3261,
    [Profession.Jewelcrafting]: 3262,
    [Profession.Leatherworking]: 3263,
    [Profession.Mining]: 3264,
    [Profession.Skinning]: 3265,
    [Profession.Tailoring]: 3266,
};
